import type { TFunction } from 'i18next'
import { setPintxoConfig } from '@/tools/ui'

export const setConfig = (t: TFunction) => {
  setPintxoConfig({
    accesibilityTags: {
      close: t('common.close'),
      collapse: t('common.collapse'),
      expand: t('common.expand'),
      next: t('common.next'),
      previous: t('common.previous'),
      getDotReference: (index: number) => t('slides.slide', { slideIndex: index + 1 }),
      getSlideOfTotal: (index: number, total: number) =>
        t('slides.current_slide_of_slides_count', { currentSlide: index + 1, slideCount: total }),
      slides: t('slides.plural'),
    },
  })
}
